<template>
	<div v-if="normalizedItems.length" data-component="faq-items" :class="{ '-embedded': isEmbedded }">
		<Accordion
			v-for="(item, index) in normalizedItems"
			:id="`${componentId}-${item.key}`"
			:key="item.key"
			:number="formatNumber(index)"
			:title="item.title"
			:text="item.text"
			:open="openKey === item.key"
			@toggle="toggleItem(item.key)"
		/>
	</div>
</template>

<script setup>
import { Accordion } from '../Accordion'

const props = defineProps({
	items: { type: Array, default: undefined },
	value: { type: Object, default: undefined },
})

const instanceId = useId()
const componentId = `faq-items-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '')}`
const openKey = ref(null)

const isEmbedded = computed(() => Boolean(props.value))
const sourceItems = computed(() => (Array.isArray(props.value?.items) ? props.value.items : props.items))
const normalizedItems = computed(() =>
	(Array.isArray(sourceItems.value) ? sourceItems.value : [])
		.map((item, index) => ({
			key: String(item?._key || index),
			title: typeof item?.title === 'string' ? item.title.trim() : '',
			text: typeof item?.text === 'string' ? item.text.trim() : '',
		}))
		.filter((item) => item.title)
)

const formatNumber = (index) => `${String(index + 1).padStart(2, '0')}.`
const toggleItem = (key) => {
	openKey.value = openKey.value === key ? null : key
}
</script>

<style lang="scss" scoped>
[data-component='faq-items'] {
	position: relative;

	&.-embedded {
		margin: rs(56, 48) 0;
	}
}
</style>
